export default function calculate ( latlongA, latlongB ) {
	const earthRadius = 6367.0
	const toRadian = ( v ) => {
		return v * ( Math.PI / 180 )
	}
	const diffRadian = ( v1, v2 ) => {
		return toRadian( v2 ) - toRadian( v1 )
	}
	return earthRadius * 2 * Math.asin( Math.min( 1, Math.sqrt( ( Math.pow( Math.sin( ( diffRadian( latlongA.lat, latlongB.lat ) ) / 2.0 ), 2.0 ) +
		Math.cos( toRadian( latlongA.lat ) ) * Math.cos( toRadian( latlongB.lat ) ) *
		Math.pow( Math.sin( ( diffRadian( latlongA.lng, latlongB.lng ) ) / 2.0 ), 2.0 ) ) ) ) )
}